import { render } from "./CookieComply.vue?vue&type=template&id=04c5181a"
import script from "./CookieComply.vue?vue&type=script&lang=js"
export * from "./CookieComply.vue?vue&type=script&lang=js"

import "./CookieComply.vue?vue&type=style&index=0&id=04c5181a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__